import React, { useState } from "react";
import "./UserSettingsModal.css";

function UserEditModal({ userInfo, onClose, onSave }) {
  const [userName, setUserName] = useState(userInfo.user_name);
  const [mailAddress, setMailAddress] = useState(userInfo.mail_address);
  const [currentPw, setCurrentPw] = useState("");
  const [newPw, setNewPw] = useState("");

  return (
    <div className="user-settings-modal-overlay">
      <div className="user-settings-modal">
        <h2>ユーザー情報の編集</h2>

        <label>ユーザー名</label>
        <input value={userName} onChange={(e) => setUserName(e.target.value)} />

        <label>メールアドレス</label>
        <input value={mailAddress} onChange={(e) => setMailAddress(e.target.value)} />

        <hr />

        <h3>パスワード変更</h3>
        <label>現在のパスワード</label>
        <input type="password" value={currentPw} onChange={(e) => setCurrentPw(e.target.value)} />

        <label>新しいパスワード</label>
        <input type="password" value={newPw} onChange={(e) => setNewPw(e.target.value)} />

        <div className="modal-buttons">
          <button onClick={() => onSave({ userName, mailAddress, currentPw, newPw })}>保存する</button>
          <button onClick={onClose}>戻る</button>
        </div>
      </div>
    </div>
  );
}

export default UserEditModal;